export const TRADITION_AUCTION_CREATE_PAGE_PATH = '/auction/tradition/create'
